import CustomApplicationState from "@theStellarBlueprint/Store/CustomApplicationState";

export const getPurchasedItemsConfigSelectionState = (state: CustomApplicationState) => {
    return state.StellarState?.LoadUserDetailsConfigSelection;
};
